import { useAdsCopilotContext } from '../components/ads-copilot-context-provider';

export function useAdsCopilotPilotMap() {
  const context = useAdsCopilotContext();
  return context?.pilotMap || {};
}
